var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandovers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.04 11.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zSTDBH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,8.94a.89.89,0,0,1,.75-.31A1.83,1.83,0,0,1,1.62,9a4.33,4.33,0,0,0,1.77.7,3.47,3.47,0,0,0,1.36-.1A4.6,4.6,0,0,0,5.92,9L6,9V9L5.66,9a8.56,8.56,0,0,1-1.24.14A1.55,1.55,0,0,1,3.86,9a.65.65,0,0,1-.38-.58l.27,0A9.44,9.44,0,0,0,5,8.1a5.39,5.39,0,0,1,1.43-.27,3.27,3.27,0,0,1,1,.14,2.64,2.64,0,0,0,.78.12H9.35a.25.25,0,0,1,.26.19c0,.16.05.32.07.48,0,.36.09.71.13,1.07a.27.27,0,0,1-.23.32l-1.21.27-1.7.37-1.5.35a3.72,3.72,0,0,1-2.35-.21A9.09,9.09,0,0,1,2,10.44c-.33-.2-.66-.41-1-.63a4.07,4.07,0,0,1-.87-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,2.3a.9.9,0,0,1-.76.3,1.74,1.74,0,0,1-.86-.33,4.44,4.44,0,0,0-1.77-.7,3.17,3.17,0,0,0-1.8.26c-.26.11-.5.26-.75.39h0l0,0,.27,0,.82-.13a2.32,2.32,0,0,1,.87,0,.65.65,0,0,1,.5.52.41.41,0,0,1,0,.11,1.35,1.35,0,0,0-.28,0l-1.06.26c-.34.09-.68.19-1,.26a3.38,3.38,0,0,1-1.67-.09A1.88,1.88,0,0,0,2,3.16c-.4,0-.8,0-1.19,0S.43,3.05.4,2.82C.35,2.38.29,1.94.24,1.49c0-.26,0-.36.3-.42L.86,1,3,.52C3.58.39,4.15.28,4.72.14a3.91,3.91,0,0,1,1-.14A3.76,3.76,0,0,1,7.79.61L9,1.36a4.35,4.35,0,0,1,1,.8l.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.17,5.84V5.4h5.7v.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.17,7.18V6.75h5.7v.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.17,4.05h5.7v.43H2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.63,2.84,9.07,3V7.72H8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,3.51h.45V8.4L1,8.29c-.06,0-.08,0-.08-.1C1,6.93,1,5.67,1,4.42V3.51Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandovers);
export default __webpack_public_path__ + "static/media/Handovers.9fe8afb74f7351b4a42c800a77228c2c.svg";
export { ForwardRef as ReactComponent };